export * from './panel.interface';
